import React from "react";

import Modal from "../Modal";
import PixelFire from "./PixelFire";
import { trackAmplitudeEvent } from "../../amplitude";

export default class StreakSaveIntroModal extends React.Component {
  componentDidMount() {
    trackAmplitudeEvent("streak_save_earned_viewed", {
      total_saves_balance: this.props.streakSaveBalance,
      current_streak_length: this.props.currentStreakDays,
      is_first_streak_save: true,
    });
    if (this.props.ackUrl) {
      $.ajax({ url: this.props.ackUrl, method: "POST", data: { type: "intro" } });
    }
  }

  onAwesomeClick() {
    trackAmplitudeEvent("streak_save_modal_tapped", { screen_type: "initial" });
    this.modal.hide();
  }

  render() {
    return (
      <Modal
        id="streak-save-intro-modal"
        ref={(el) => this.modal = el}
        size="small"
        title="Streak Save"
        onHidden={this.props.onHidden}
      >
        <div className="text-center">
          <div style={{ marginBottom: 16, display: "flex", justifyContent: "center" }}><PixelFire size={72} /></div>
          <h3>This one's on us</h3>
          <p style={{ marginBottom: 24 }}>
            Rest is part of the work. Every 6 days of learning earns you a Streak Save. Use it for a well-deserved day off!
          </p>
          <button className="btn btn-success btn-block joystix btn-lg" onClick={() => this.onAwesomeClick()}>
            Awesome!
          </button>
        </div>
      </Modal>
    );
  }
}
